import {
  LANDING_PAGE_ECOSYSTEM_ROLES,
  LANDING_PAGE_SECTION,
  LANDING_PAGE_UI,
} from '@propbix/constants/public'
import { Reveal } from '@/components/Reveal'

const hubRoleId = 'owner'

export function EcosystemMap() {
  const hub = LANDING_PAGE_ECOSYSTEM_ROLES.find((r) => r.id === hubRoleId)
  const spokes = LANDING_PAGE_ECOSYSTEM_ROLES.filter((r) => r.id !== hubRoleId)

  return (
    <section
      id={LANDING_PAGE_SECTION.platform}
      className="section-band"
      aria-labelledby="platform-heading"
    >
      <div className="page-shell section-y">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="section-label">{LANDING_PAGE_UI.platformLabel}</p>
          <h2 id="platform-heading" className="section-title mt-3">
            {LANDING_PAGE_UI.platformTitle}
          </h2>
          <p className="section-body mx-auto mt-5">{LANDING_PAGE_UI.platformSubtitle}</p>
        </Reveal>

        <Reveal delay={0.08} className="mt-14">
          {hub !== undefined ? (
            <div className="mx-auto max-w-2xl rounded-[var(--radius-desk)] border border-accent/30 bg-gradient-to-br from-accentSoft/70 to-panel px-6 py-6 text-center shadow-[var(--shadow-float)] dark:from-accentSoft/25 dark:to-panel md:px-10 md:py-8">
              <p className="text-[0.6rem] font-semibold uppercase tracking-[0.16em] text-accent">
                {LANDING_PAGE_UI.platformPrimaryActorLabel}
              </p>
              <h3 className="mt-2 font-display text-xl font-semibold tracking-tight text-ink md:text-2xl">
                {hub.label}
              </h3>
              <p className="mx-auto mt-2 max-w-[46ch] text-sm leading-6 text-muted md:text-base md:leading-7">
                {hub.description}
              </p>
              <div className="mt-5 flex flex-wrap justify-center gap-1.5">
                {hub.surfaces.map((s) => (
                  <span
                    key={s}
                    className="inline-block rounded-[0.4rem] border border-accent/20 bg-accentSoft/60 px-2.5 py-1 text-[0.65rem] font-medium text-accent dark:bg-accentSoft/20 dark:text-accentGlow"
                  >
                    {s}
                  </span>
                ))}
              </div>
              <p className="mx-auto mt-5 max-w-[40ch] text-xs leading-5 text-muted">
                <span className="font-semibold text-accent">{LANDING_PAGE_UI.platformSyncLabel}. </span>
                {LANDING_PAGE_UI.platformSyncBody}
              </p>
            </div>
          ) : null}

          <ul className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {spokes.map((role) => (
              <li
                key={role.id}
                className="rounded-[var(--radius-card)] border border-line/10 bg-panel p-5"
              >
                <h3 className="text-sm font-semibold tracking-tight text-ink">{role.label}</h3>
                <p className="mt-2 text-sm leading-6 text-muted">{role.description}</p>
                {role.surfaces.length > 0 ? (
                  <div className="mt-4 flex flex-wrap gap-1.5">
                    {role.surfaces.map((s) => (
                      <span
                        key={s}
                        className="inline-block rounded-[0.4rem] border border-line/10 bg-surface px-2 py-0.5 text-[0.6rem] font-medium text-muted"
                      >
                        {s}
                      </span>
                    ))}
                  </div>
                ) : null}
                {role.honesty !== null ? (
                  <p className="mt-3 text-[0.7rem] leading-5 text-amber-700 dark:text-amber-300">
                    {role.honesty}
                  </p>
                ) : null}
              </li>
            ))}
          </ul>

          <p className="mx-auto mt-10 max-w-[46ch] text-center text-sm font-medium leading-6 text-muted">
            {LANDING_PAGE_UI.platformHonesty}
          </p>
        </Reveal>
      </div>
    </section>
  )
}
